import React from 'react';
import { Header, Divider } from 'semantic-ui-react';
import styled from 'styled-components';
import MealTable from './MealTable';
import MenuTotalCBGU from './MenuTotalCBGU';
import {
  MEAL_DEFAULT_TIMES,
  SMALLER_DAY_VIOLATION,
  BIGGEST_DAY_VIOLATION,
  NONE_DAY_VIOLATION,
} from '../../../constants/appConstants';

const MenuForDay = React.memo(
  ({
    dayNumber,
    mealsData,
    changeDishPortion,
    changeDish,
    addDish,
    deleteDish,
    changeMealTime,
    changeDishTime,
    countTotalFitValuesByDay,
    dayViolation,
    cbgucalories,
    isCreateTemplate,
  }) => {
    if (!mealsData) return null;

    const totalCalories = countTotalFitValuesByDay(mealsData, 'calories');
    const totalProteins = countTotalFitValuesByDay(mealsData, 'proteins');
    const totalFats = countTotalFitValuesByDay(mealsData, 'fats');
    const totalCarbohydrates = countTotalFitValuesByDay(mealsData, 'carbohydrates');

    return (
      <MenuForDayWrap>
        <Header as="h1" textAlign="center" style={{ marginBottom: 0 }}>
          День {dayNumber}
        </Header>
        {dayViolation && dayViolation.violations === BIGGEST_DAY_VIOLATION && (
          <ErrorText>Дневная норма КБЖУ в этом меню для данного клиента превышена</ErrorText>
        )}
        {dayViolation && dayViolation.violations === SMALLER_DAY_VIOLATION && (
          <ErrorText>Дневная норма КБЖУ в этом меню ниже нормы</ErrorText>
        )}
        <MenuTotalCBGU
          isRedHead={dayViolation && dayViolation.violations !== NONE_DAY_VIOLATION}
          title="Всего за ДЕНЬ:"
          totalCalories={totalCalories}
          totalProteins={totalProteins}
          totalFats={totalFats}
          totalCarbohydrates={totalCarbohydrates}
          cbgucalories={cbgucalories}
          isCreateTemplate={isCreateTemplate}
        />
        {mealsData.map((eating) => {
          let mealTime = MEAL_DEFAULT_TIMES[eating.type];
          if (eating.meals.length && eating.type !== 'morning') {
            mealTime = eating.meals[0].time;
          }
          return (
            <MealTable
              isRedHead={dayViolation && dayViolation.violations !== NONE_DAY_VIOLATION}
              key={eating.type + eating.title}
              title={eating.title}
              meals={eating.meals}
              dayIndex={dayNumber - 1}
              type={eating.type}
              changeDishPortion={changeDishPortion}
              changeDish={changeDish}
              addDish={addDish}
              deleteDish={deleteDish}
              time={mealTime}
              changeMealTime={changeMealTime}
              changeDishTime={changeDishTime}
            />
          );
        })}
        <Divider />
      </MenuForDayWrap>
    );
  },
);

export default MenuForDay;

const MenuForDayWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

const ErrorText = styled.div`
  text-align: center;
  color: red;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/MenuBlock/MenuForDay.jsx